import React from 'react'
import Img from 'gatsby-image'

export const Image = props => <Img {...props} />
